var map = {
	"./add-ride/add-ride.module": [
		"./src/app/admin/manage-rides/add-ride/add-ride.module.ts",
		"common",
		"add-ride.module"
	],
	"./driver-detail/driver-detail.module": [
		"./src/app/admin/manage-drivers/driver-detail/driver-detail.module.ts",
		"common",
		"driver-detail.module"
	],
	"./manage-drivers/manage-drivers.module": [
		"./src/app/admin/manage-drivers/manage-drivers.module.ts",
		"common",
		"manage-drivers.module"
	],
	"./manage-email-template/manage-email-template.module": [
		"./src/app/admin/manage-email-template/manage-email-template.module.ts",
		"common",
		"manage-email-template.module"
	],
	"./manage-message/manage-message.module": [
		"./src/app/admin/manage-message/manage-message.module.ts",
		"common",
		"manage-message.module"
	],
	"./manage-notification/manage-notification.module": [
		"./src/app/admin/manage-notification/manage-notification.module.ts",
		"common",
		"manage-notification.module"
	],
	"./manage-payment/manage-payment.module": [
		"./src/app/admin/manage-payment/manage-payment.module.ts",
		"common",
		"manage-payment.module"
	],
	"./manage-promo-code/manage-promo-code.module": [
		"./src/app/admin/manage-promo-code/manage-promo-code.module.ts",
		"common",
		"manage-promo-code.module"
	],
	"./manage-referral-system/manage-referral-system.module": [
		"./src/app/admin/manage-referral-system/manage-referral-system.module.ts",
		"common",
		"manage-referral-system.module"
	],
	"./manage-reports/manage-reports.module": [
		"./src/app/admin/manage-reports/manage-reports.module.ts",
		"common",
		"manage-reports.module"
	],
	"./manage-riders/manage-riders.module": [
		"./src/app/admin/manage-riders/manage-riders.module.ts",
		"common",
		"manage-riders.module"
	],
	"./manage-rides/manage-rides.module": [
		"./src/app/admin/manage-rides/manage-rides.module.ts",
		"common",
		"manage-rides.module"
	],
	"./manage-setting/manage-setting.module": [
		"./src/app/admin/manage-setting/manage-setting.module.ts",
		"common",
		"manage-setting.module"
	],
	"./rider-detail/rider-detail.module": [
		"./src/app/admin/manage-riders/rider-detail/rider-detail.module.ts",
		"common",
		"rider-detail.module"
	],
	"app/admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"admin.module"
	],
	"app/admin/dashboard/dashboard.module": [
		"./src/app/admin/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"app/admin/manage-referral-system/referral-details/referral-driver-details/referral-driver-details.module": [
		"./src/app/admin/manage-referral-system/referral-details/referral-driver-details/referral-driver-details.module.ts",
		"common",
		"referral-driver-details.module"
	],
	"app/admin/manage-referral-system/referral-details/referral-rider-details/referral-rider-details.module": [
		"./src/app/admin/manage-referral-system/referral-details/referral-rider-details/referral-rider-details.module.ts",
		"common",
		"referral-rider-details.module"
	],
	"app/auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"app/auth/reset-password/reset.module": [
		"./src/app/auth/reset-password/reset.module.ts",
		"reset.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main